import ComposeMessageButton from '../../compose/components/ComposeMessageButton';
import CustomViewsFooterLink from './CustomViewsFooterLink';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useSelector } from 'react-redux';
import styled from 'foundations-theming/utils';
import { getAvailabilityManagementUrl } from '../../urls/inboxSettingsUrls';
import { Button } from 'foundations-components/transitional/components/Button';
import { Dropdown } from 'foundations-components/transitional/components/Dropdown';
import { List } from 'foundations-components/transitional/components/List';
import { getCurrentInboxId } from 'conversations-inbox-lib/unified-inbox/public/selectors';
import { getIsConversationsAdmin } from '../../selectors/userSelectors/getIsConversationsAdmin';
import { getHasAvailabilityManagementWriter } from '../../selectors/userSelectors/getHasAvailabilityManagementWriter';
import { getSelectChannelUrl } from '../../unified-inbox/operators/getSelectChannelUrl';
import { getUserHasCustomViewsAccess } from '../../selectors/userSelectors/getUserHasCustomViewsAccess';
import { trackConnectChannel } from '../../unified-inbox/operators/trackConnectChannel';
import { trackLinkClick } from '../../usage-tracking/utils/trackLinkClick';
import { withFromInbox } from '../../urls/withFromInbox';
import { useUpgradeModal } from 'ui-addon-upgrades/ums/useUpgradeModal';
import { getIsAdminNotMemberOfInbox } from '../../unified-inbox/selectors/getIsAdminNotMemberOfInbox';
import WhatsAppCoachingModal from '../../whatsapp/WhatsAppCoachingModal';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FooterActions = ({
  onCreateCustomViewClick
}) => {
  const {
    openUpgradeModal
  } = useUpgradeModal('custom-views-inbox-footer-actions');
  const inboxId = useSelector(getCurrentInboxId);
  const isAdmin = useSelector(getIsConversationsAdmin);
  const hasAMWrite = useSelector(getHasAvailabilityManagementWriter);
  const userHasCustomViewsAccess = useSelector(getUserHasCustomViewsAccess);
  if (!isAdmin && !userHasCustomViewsAccess) {
    return null;
  }
  const handleTeamAvailabilityClick = event => {
    void trackLinkClick({
      event,
      name: 'opened-inbox-settings',
      meta: {
        action: 'opened inbox settings',
        setting: 'team'
      },
      href: getAvailabilityManagementUrl()
    });
  };
  const handleConnectChannelClick = trackConnectChannel({
    href: withFromInbox(getSelectChannelUrl(inboxId), true)
  });
  return /*#__PURE__*/_jsx(WhatsAppCoachingModal, {
    children: /*#__PURE__*/_jsx(Flex, {
      flex: "1",
      marginInlineEnd: "300",
      children: /*#__PURE__*/_jsx(Dropdown, {
        buttonStyles: {
          inlineSize: '100%'
        },
        buttonText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "conversations-inbox-ui.buttons.actions"
        }),
        buttonUse: "tertiary-light",
        buttonSize: "small",
        "data-test-id": "nav-sidebar-footer-actions-dropdown",
        popoverProps: {
          placement: 'top right'
        },
        children: /*#__PURE__*/_jsxs(List, {
          wrapChildren: true,
          children: [hasAMWrite && /*#__PURE__*/_jsx(Button, {
            onClick: handleTeamAvailabilityClick,
            "data-test-id": "team-availability-button",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "conversations-inbox-ui.viewsSidebar.actions.teamAvailability"
            })
          }), /*#__PURE__*/_jsx(CustomViewsFooterLink, {
            openUpgradeModal: openUpgradeModal,
            onCreateCustomViewClick: onCreateCustomViewClick
          }), isAdmin && /*#__PURE__*/_jsx(Button, {
            onClick: handleConnectChannelClick,
            "data-test-id": "connect-channel-button",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "conversations-inbox-ui.viewsSidebar.actions.connectChannel"
            })
          })]
        })
      })
    })
  });
};
FooterActions.displayName = 'FooterActions';
const ButtonsWrapper = styled.div.withConfig({
  displayName: "FooterActionsSection__ButtonsWrapper",
  componentId: "sc-1qzxehx-0"
})(["display:flex;border-block-start:1px solid ", ";padding-block:", ";padding-inline-end:", ";padding-inline-start:", ";inline-size:100%;&:empty{border:none;padding:0;}"], ({
  theme
}) => theme.color['border-core-subtle'], ({
  theme
}) => theme.space['300'], ({
  theme
}) => theme.space['0'], ({
  theme
}) => theme.space['300']);
const FooterActionsSection = ({
  onCreateCustomViewClick
}) => {
  const isAdminNotMemberOfInbox = useSelector(getIsAdminNotMemberOfInbox);
  return (
    /*#__PURE__*/
    // @bend-expect trellis-tokenized
    _jsxs(ButtonsWrapper, {
      children: [/*#__PURE__*/_jsx(FooterActions, {
        onCreateCustomViewClick: onCreateCustomViewClick
      }), !isAdminNotMemberOfInbox && /*#__PURE__*/_jsx(ComposeMessageButton, {
        inlineSize: "100%",
        flexGrow: 1,
        marginInlineEnd: "300",
        size: "small",
        use: "tertiary"
      })]
    })
  );
};
FooterActionsSection.displayName = 'FooterActionsSection';
export default FooterActionsSection;